import React from "react";
import Style from './Avatar.module.css'

const Avatar = (props) => {
  const { name, cssClass } = props;  
  const getInitials = (name) => {
    if (!name) return '';
    return name
      .split(" ")
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase();
  };

  return (
    <div className={`${cssClass} ${Style.avatarWrapper}`}>
      <p>{getInitials(name)}</p>
    </div>
  );
};

export default Avatar;
